export enum UserStatusEnum {
    Active = 'active',
    Pending = 'pending',
    Blocked = 'blocked',
}
